/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  detail_issue: "",
  photo_issue: "",
  select_org: "",
  select_problemtype: "",
};

export const DetailReportSlice = createSlice({
  name: "mapPosition",
  initialState: initialState,
  reducers: {
    saveDetailReport: (state, action) => {
      state.detail_issue = action.payload.detail_issue;
      state.photo_issue = action.payload.photo_issue;
      state.select_org = action.payload.select_org;
      state.select_problemtype = action.payload.select_problemtype;
    },
  },
});

export const { saveDetailReport } = DetailReportSlice.actions;
export default DetailReportSlice.reducer;
